"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var constants_1 = require("../../constants");
var checkOnRoute_1 = __importDefault(require("./checkOnRoute"));
var getSportTypeFromLocation = function () {
    switch (true) {
        case checkOnRoute_1.default(types_1.App.Routes.CLASSIC): {
            return constants_1.SportType.Classic;
        }
        case checkOnRoute_1.default(types_1.App.Routes.ESPORT): {
            return constants_1.SportType.Esport;
        }
        default: {
            return constants_1.SportType.Mix;
        }
    }
};
exports.default = getSportTypeFromLocation;
//# sourceMappingURL=getSportTypeFromLocation.js.map